import "../fontawesome";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface SelectionItemProps {
  name?: String;
  onClick?: () => void;
}

export const SelectionSelectorItem = ({
  name,
  onClick,
}: SelectionItemProps) => {
  return (
    <div
      onClick={onClick}
      style={{
        width: "100%",
        cursor: "pointer",
        minHeight: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingLeft: "5%",
        borderBottomWidth: 1,
        borderColor: "#284F82",
      }}
    >
      <div
        style={{ paddingTop: "3%", paddingBottom: "3%", paddingRight: "3%" }}
      >
        <p style={{ color: "#284F82" }}>{name}</p>
      </div>
      <div style={{ paddingRight: "7%" }}>
        <FontAwesomeIcon color="#284f82" icon="chevron-right" />
      </div>
    </div>
  );
};
